import PropTypes from 'prop-types';
import React from 'react';
import { formatDateTime } from '../../dateUtils';

import InlineInputControlRow from '../../ui/layout/InlineInputControlRow';
import LeftRightSplit from '../../ui/LeftRightSplit';
import TextBox from '../../ui/TextBox';
import useSuntekSettings from '../../hooks/useSuntekSettings';

function LastUpdateInfo({updateDate, updateBy, showBy, noabsolute }: { updateDate: string|null|undefined, updateBy: string|null|undefined, showBy: boolean, noabsolute: boolean }) {
  const suntekSettings = useSuntekSettings();
  let absoluteclass = noabsolute ? "doc-update-section-bottom-noabsolute": "doc-update-section-bottom";
  return (
    <div className={absoluteclass}>
      <InlineInputControlRow mode="w90" label="Last Update" >
        <LeftRightSplit
          leftSize="calc(100% - 123px)"
          rightSize="123px"
          left={
            <TextBox name ='last-update' value={formatDateTime(updateDate, suntekSettings.company?.dateFormat.toUpperCase() ?? '', false, true)} disabled />
          }
          right={
            <div>
              {showBy ?
               <TextBox name = 'last-updateBy' value={updateBy || ''} disabled />    
               : <></>
              }
            </div>
          }
        />
      </InlineInputControlRow>
    </div>
  );
}

LastUpdateInfo.defaultProps = {
  showBy: true,
  noabsolute: false,
};

LastUpdateInfo.propTypes = {
  updateDate: PropTypes.string,
  updateBy: PropTypes.string,
  showBy: PropTypes.bool,
  noabsolute: PropTypes.bool,
};


export default React.memo(LastUpdateInfo);
